const CirquidOffers = () => {
    return (
        <div id="cirquid-embed"></div>
    )
}

export default CirquidOffers;